var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#008ECF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1152 16.5495C30.0918 16.5495 26.0079 20.6333 26.0079 25.6567C26.0079 30.5842 29.8618 34.5722 34.8851 34.7448C35.0385 34.7256 35.1919 34.7256 35.3069 34.7448C35.3453 34.7448 35.3644 34.7448 35.4028 34.7448C35.422 34.7448 35.422 34.7448 35.4411 34.7448C40.3495 34.5722 44.2033 30.5842 44.2224 25.6567C44.2224 20.6333 40.1386 16.5495 35.1152 16.5495Z",
    fill: "#008ECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8551 39.8448C39.5058 36.2786 30.7821 36.2786 25.3944 39.8448C22.9594 41.4746 21.6173 43.6795 21.6173 46.0378C21.6173 48.3961 22.9594 50.5818 25.3752 52.1923C28.0595 53.9946 31.5873 54.8958 35.1152 54.8958C38.643 54.8958 42.1709 53.9946 44.8551 52.1923C47.271 50.5626 48.6131 48.3769 48.6131 45.9994C48.5939 43.6411 47.271 41.4554 44.8551 39.8448Z",
    fill: "#008ECF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.612e880d8b6e0ff923b8345916e970bd.svg";
export { ForwardRef as ReactComponent };